<template>
    <div class="main">
        <h1 style="text-align: center;">欢迎登陆AI云盒</h1>
        <a-form-model layout="horizontal" :model="formInline" @submit="handleSubmit" @submit.native.prevent>
            <a-form-model-item>
                <a-input v-model="formInline.username" placeholder="用户名">
                    <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                </a-input>
            </a-form-model-item>
            <a-form-model-item>
                <a-input v-model="formInline.password" type="password" placeholder="密码">
                    <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                </a-input>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" html-type="submit">
                    登录
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>
  
<script>
import request from '@/api/index'

export default {
    name: 'login',
    components: {
    },
    data() {
        return {
            formInline: {
                username: '',
                password: '',
            },
        };
    },
    methods: {
        handleSubmit() {
            let password = this.formInline.password
            let username = this.formInline.username
            request({ url: 'http://dl.tl.run/proxy/login/' + username + '/' + password }).then((res) => {
                if (res.data.success) {
                    this.$router.push({ path: '/home' })
                } else {
                    this.$message.info('账号名/密码错误，请检查后再试');
                }
            })

        },
    },
}
</script>
  
<style scoped>
button{
    width: 100%;
    background-color: rgb(148,191,255);
    border: none;
}
.main {
    width: 400px;
    height: 300px;
    border-radius: 10px;
    box-shadow: 0 0 10px #ccc;
    padding: 20px;
    margin: 200px  auto 0;
}
</style>
  